import { AddressForm } from 'components/molecules';
import LabelFormStep from 'components/templates/label-form-step/LabelFormStep';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { ILabelForm } from 'services/labels/types';

const LabelAddressStep = () => {
  const { t } = useTranslation();
  const formik = useFormikContext<ILabelForm>();
  return (
    <LabelFormStep
      header={t('label.form.address.header')}
      description={t('label.form.address.description')}>
      <AddressForm propertyPrefix='address.' noMaxWidth noHeader />
    </LabelFormStep>
  );
};

export default LabelAddressStep;
